export default "__VITE_ASSET__BdkJMn8m__"